import { IbranchTypeCodes, IKIOSKModel, IkioskMenuIds } from '../../models/kioskModel';
import * as types from './actionTypes'
const initialState = {} as IKIOSKModel;

const kioskReducer = (state = initialState as IKIOSKModel, action) => {
    let undefinedData;
    switch (action.loadingType) {
        case types.SET_LOADING:
            state = {
                ...state,
                loading: action.loadPayload
            }
            break;
        default:
            break;
    }
    switch (action.type) {
        case types.SET_LOADING:
            state = {
                ...state,
                loading: action.loadPayload
            }
            break;
        case types.KIOSK_ID_AND_GET_MENUS_DATA_RESPONSE:
            const { kioskId, welcomeMenus, kioskConfigData, otherServicesMenu, errorMessage, kioskStartTime, kioskEndTime, kioskIdentifier, kioskType, locationId, logInMenus, isNewPatientRegistration, isWalkin, actiontype, selectedPage, clientlogo, promotionalData,idleTime } = action.payload;
            if (actiontype) {
                state = {
                    ...state,
                    kioskId: kioskId,
                    kioskIdentifier: kioskIdentifier,
                    kioskStartTime: kioskStartTime,
                    kioskEndTime: kioskEndTime,
                    kioskType: kioskType,
                    clientlogo: clientlogo,
                    locationId: locationId,
                    logInMenus: logInMenus,
                    selectedPage: selectedPage,
                    otherServicesMenus: otherServicesMenu,
                    welcomeMenus: welcomeMenus,
                    kioskConfigdata: kioskConfigData,
                    isWalkin: isWalkin,
                    isNewpatientRegistration: isNewPatientRegistration,
                    promotionalData: promotionalData,
                    idleTime:idleTime
                }
            }
            else {
                state = {
                    ...state,
                    kioskStartTime: kioskStartTime,
                    kioskEndTime: kioskEndTime,
                    isWalkin: isWalkin,
                    locationId: locationId,
                    isNewpatientRegistration: isNewPatientRegistration,
                    selectedPage: selectedPage,
                    logInMenus: logInMenus,
                    promotionalData: promotionalData,
                    idleTime:idleTime
                }
            }
            if (errorMessage) {
                state = {
                    ...state,
                    errorMessage: errorMessage
                }
            }
            break;
        case types.MENU_TYPE:
            state = {
                ...state,
                selectedPage: action.payload,
                errorMessage: "",
                otherserviceErrorMessage: "",
                authFailMessage: ""
            }
            break;
        case types.MOBILE_VERIFICATION_RESPONSE:
            state = {
                ...state,
                patientId: action.payload.patientId,
                errorMessage: action.payload.errorMessage,
                selectedPage: action?.payload?.selectedPage
            }
            break;
        case types.QRCODE_VERIFICATION_REQUEST:
            state = {
                ...state,
                patientId: action.payload.patientId,
                errorMessage: action.payload.errorMessage,
                selectedPage: action?.payload?.selectedPage
            }
            break;
        case types.EMIRATESID_RESPONSE:
            if (action.payload.errorMessage)
                state = {
                    ...state,
                    emiratesData: undefinedData,
                    emiratesId: undefinedData,
                    authFailMessage: action.payload.errorMessage,
                    selectedPage: IkioskMenuIds.AUTHFAILED,
                }
            else
                state = {
                    ...state,
                    emiratesData: action.payload.data,
                    emiratesId: action.payload.emiratesId,
                    errorMessage: ''
                }
            break;
        case types.EMIRATES_VERIFICATION_RESPONSE:
            if (action.payload.errorMessage)
                state = {
                    ...state,
                    emiratesData: undefinedData,
                    emiratesId: undefinedData,
                    authFailMessage: action.payload.errorMessage,
                    selectedPage: IkioskMenuIds.AUTHFAILED
                }
            else
                state = {
                    ...state,

                    patientId: action.payload.patientId,
                    errorMessage: undefinedData,
                    selectedPage: action?.payload?.selectedPage
                }
            break;
        case types.SETRESET_ACTION:
            state = {
                ...state,
                emiratesData: undefinedData,
                emiratesId: undefinedData,
                errorMessage: "",
                language: undefinedData,
                selectedPage: IkioskMenuIds.LOGINPAGE,
                loading: false,
                tokenData: undefinedData,
                appoinmenttype: IbranchTypeCodes.CLINICAL,
                mobileNumber: undefinedData,
                tokenType: 0
            }
            break;
        case types.CHECKIN_REPRINT_TOCKEN:
            state = {
                ...state,
                tokenData: action?.payload,
                selectedPage: IkioskMenuIds.TOKEN
            }
            break;
        case types.GENERATE_CHECKIN_TOKEN_RESPONSE:
            if (action.payload?.errorMessage)
                state = {
                    ...state,
                    errorMessage: action.payload?.errorMessage
                }
            else
                state = {
                    ...state,
                    tokenData: action?.payload?.tokenData,
                    selectedPage: IkioskMenuIds.TOKEN,
                    appointmentsData: action?.payload?.appointmentsData,
                    tokenType: action.payload?.tokenType,
                    errorMessage: ""
                }
            break;
        case types.GENERATE_OTHERSERVICES_TOKEN_RESPONSE:
            if (action.payload?.errorMessage)
                state = {
                    ...state,
                    otherserviceErrorMessage: action.payload?.errorMessage
                }
            else
                state = {
                    ...state,
                    tokenData: action?.payload?.tokenData,
                    selectedPage: IkioskMenuIds.TOKEN,
                    tokenType: action.payload?.tokenType,
                    otherserviceErrorMessage: ""
                }

            break;
        case types.REPRINT_TOCKEN_RESPONSE:
            if (action.payload?.errorMessage)
                state = {
                    ...state,
                    errorMessage: action.payload?.errorMessage
                }
            else
                state = {
                    ...state,
                    tokenData: action?.payload?.tokenData,
                    selectedPage: IkioskMenuIds.TOKEN,
                    tokenType: action.payload?.tokenType,
                    errorMessage: ""
                }

            break;
        case types.APPOINTMENTS_RESPONSE:
            if (action?.payload?.errorMessage)
                state = {
                    ...state,
                    appointmentsData: undefinedData,
                    errorMessage: action?.payload?.errorMessage
                }
            else
                state = {
                    ...state,
                    appointmentsData: action.payload.appointmentsData,
                    errorMessage: ''
                }
            break;
        case types.SELECTED_APPOIN_TYPE:
            state = {
                ...state,
                appoinmenttype: action?.payload,
                selectedPage: IkioskMenuIds.APPOINMENTS
            }
            break;
        case types.GET_CURRENT_TIME_RESPONSE:
            state = {
                ...state,
                currentDateAndTime: action?.payload
            }
            break;
        case types.PRINT_TOCKEN_RESPONSE:
            state = {
                ...state,
                errorMessage: action?.payload?.errorMessage
            }
            break;
        case types.QRCODE_VERIFICATION_RESPONSE:
            if (action.payload.errorMessage)
                state = {
                    ...state,
                    authFailMessage: action.payload.errorMessage,
                    selectedPage: IkioskMenuIds.AUTHFAILED
                }
            else
                state = {
                    ...state,

                    patientId: action.payload.patientId,
                    errorMessage: undefinedData,
                    selectedPage: action?.payload?.selectedPage
                }
            break;
        case types.MOBILENUMBER:
            state = {
                ...state,
                mobileNumber: action.payload
            }
            break;
        case types.GET_PROMOTIONAL_FILES_RESPONSE:
            state = {
                ...state,
                promotionalData: action.payload
            }
            break;
        case types.CHANGE_LANGUGAE:
            state = {
                ...state,
                language: action.payload
            }
            break;
        case types.SET_LOGIN_PAGE:
            state = {
                ...state,
                loginPage: action.payload
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}
export default kioskReducer;